import React, { useState, useEffect, useRef } from 'react';
import './DropDown.scss';

function DropDown({ data, placeholder, value, onChange }) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(data.find(item => item.value === value)[0] || {});
    const dropdownRef = useRef(null);

    const handleFocus = () => {
        setIsOpen(prevState => !prevState);
    };

    const handleOptionClick = (option) => {
        setIsOpen(false);
        onChange(option);
        setSelectedOption(option);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setSelectedOption(data.find(item => item.value === value) || {});
    }, [value, data]);

    return (
        <div className={`dropdown ${isOpen ? 'active' : ''}`} ref={dropdownRef}>

            <div className="textBox" onClick={handleFocus}>
                <span>{selectedOption.label || placeholder}</span>
                {selectedOption.icon && <img src={selectedOption.icon} alt={`${selectedOption.label} icon`} className='icon' />}
            </div>

            {isOpen && (
                <div className={`option ${isOpen ? 'active' : ''}`}>
                    {data.map((item, index) => (
                        <div
                            key={index}
                            className='select'
                            onClick={() => handleOptionClick(item)}
                        >
                            <span>{item.label}</span>
                            {item.icon && <img src={item.icon} alt={`${item.label} icon`} className='icon' />}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default DropDown;
